/** @format */

import {prettyProductLabel} from '../../../../ds/quoter/functions/format';
import {useParams, useNavigate, useSearchParams} from 'react-router-dom';
import {SearchContext} from '../../../../components/search';
import {Modal, ModalHeader} from '@sttark/design-system';
import {IfElse} from '../../../../utilities';
import React, {useContext} from 'react';

// styles
import './view_invoice.scss';
import {singlePrettyAddress} from '../../../../cart/helpers/format';

export const ViewInvoice = () => {
    const searchCtx = useContext(SearchContext);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const params = useParams();

    const isChargeBatch = searchParams.get('isChargeBatch');
    const invoiceId = params.invoiceId;

    const invoice = searchCtx.listItems.find(invoice => invoice.id === Number(invoiceId)) || {};

    const handleClose = () => {
        navigate(-1);
    };

    return (
        <Modal className="view-invoice-75cs" onClose={handleClose} isOpen={true} zIndex={3000}>
            <ModalHeader>
                <div className={'d-flex align-items-center justify-content-between'}>
                    <button
                        className="btn btn--secondary d-flex align-items-center justify-content-center"
                        onClick={handleClose}>
                        Close
                    </button>
                    <a
                        href={`/account/orders/preview-current-invoice/${invoice.id}`}
                        target="_blank"
                        rel={'noopener noreferrer'}>
                        <button className="btn btn--secondary d-flex align-items-center justify-content-center gap-2">
                            <i className="fa fa-print" />
                            <b>Print invoice</b>
                        </button>
                    </a>
                </div>
            </ModalHeader>
            <IfElse condition={!isChargeBatch}>
                <section>
                    <section className={'view-invoice-75cs__invoice-id'}>
                        <h3>Invoice #{invoice.id}</h3>
                    </section>

                    <section className="view-invoice-75cs__tables">
                        {invoice.orders?.map(order => (
                            <div key={order.id} className="view-invoice-75cs__table-container">
                                <h4>Order #{order.id}</h4>
                                <table key={order.id} width="100%">
                                    <thead>
                                        <tr>
                                            <th>Type</th>
                                            <th>Description</th>
                                            <th>Qty</th>
                                            <th>Price</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{order.product_type_label}</td>
                                            <td>
                                                <div>
                                                    <p>
                                                        <b>Size / Shape: </b>
                                                        {prettyProductLabel(
                                                            order.size_description,
                                                            order.product_type_id
                                                        )}
                                                    </p>
                                                    <p>
                                                        <b>Material: </b>
                                                        {order.substrate_label}
                                                    </p>
                                                    <p>
                                                        <b>Laminate:</b>
                                                        {order.laminate_label}
                                                    </p>
                                                    <p>
                                                        <b>Design Qty: </b>
                                                        {order.design_qty}
                                                    </p>
                                                    <p>
                                                        <b>Color: </b>
                                                        {order.color_label}
                                                    </p>
                                                    <p>
                                                        <b>Processing: </b>
                                                        {order.processing_label}
                                                    </p>
                                                    <p>
                                                        <b>Processing: </b>
                                                        {order.form_factor_label}
                                                    </p>
                                                </div>
                                            </td>
                                            <td>{order.total_qty}</td>
                                            <td>{order.quoted_total}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        ))}
                    </section>
                    <section className="view-invoice-75cs__shipping">
                        <h4>Addresses</h4>
                        <div className="view-invoice-75cs__table-container">
                            <table width="100%">
                                <thead>
                                    <tr>
                                        <th>
                                            <h6>Shipping address</h6>
                                        </th>
                                        <th>
                                            <h6>Billing Address</h6>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <p>
                                                {singlePrettyAddress(
                                                    invoice?.shipping_address,
                                                    'shipping'
                                                )}
                                            </p>
                                        </td>
                                        <td>
                                            <p>
                                                {singlePrettyAddress(
                                                    invoice?.shipping_address,
                                                    'billing'
                                                )}
                                            </p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </section>

                    <section>
                        <h5 className="d-flex align-items-center justify-content-between">
                            <span>Sub-Total</span>
                            <span>${invoice.subtotal}</span>
                        </h5>
                        <h5 className="d-flex align-items-center justify-content-between">
                            <span>Shipping - {invoice.shipping_method_name}</span>
                            <span>${invoice.shipping}</span>
                        </h5>
                        <h5 className="d-flex align-items-center justify-content-between">
                            <span>Tax</span>
                            <span>${invoice.tax}</span>
                        </h5>
                        <h3 className="d-flex align-items-center justify-content-between">
                            <span>Total</span>
                            <span>${invoice.total}</span>
                        </h3>
                    </section>
                </section>
                <section>
                    <div className="view-invoice-75cs__table-container">
                        <table width="100%">
                            <thead>
                                <tr>
                                    <th>
                                        <h6>Ship to</h6>
                                    </th>
                                    <th>
                                        <h6>Bill to</h6>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <p>testesfe es esdfd</p>
                                    </td>
                                    <td>
                                        <p>32 sfdsf dsf</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>
            </IfElse>
        </Modal>
    );
};
